/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetConnectingVisitsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetConnectingVisitsQuery = {
  __typename?: 'Query',
  connectingVisits?: Array<{
    __typename?: 'ConnectingVisit',
    id: number,
    externalId?: string | null,
    eta?: number | null,
    ata?: number | null,
    etd?: number | null,
    atd?: number | null,
    cargoOpening?: number | null,
    cargoClosing?: number | null,
    cargoAvailableStart?: number | null,
    cargoAvailableEnd?: number | null,
    callReferenceNumber?: string | null,
    portName?: string | null,
    type?: Types.ConnectingType | null,
    status?: Types.ConnectingVisitStatus | null,
    numLoadingGreen: number,
    numLoadingOrange: number,
    numLoadingRed: number,
    numDischargingGreen: number,
    numDischargingOrange: number,
    numDischargingRed: number,
    vessel?: {
      __typename?: 'ConnectingVessel',
      id: number,
      name: string
    } | null,
    port?: {
      __typename?: 'Location',
      id: number,
      code?: string | null,
      displayCode?: string | null,
      description: string
    } | null
  }> | null
};

export type GetConnectingVisitQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetConnectingVisitQuery = {
  __typename?: 'Query',
  connectingVisit: {
    __typename?: 'ConnectingVisit',
    id: number,
    callReferenceNumber?: string | null,
    status?: Types.ConnectingVisitStatus | null,
    eta?: number | null,
    ata?: number | null,
    etd?: number | null,
    atd?: number | null,
    cargoOpening?: number | null,
    cargoClosing?: number | null,
    cargoAvailableStart?: number | null,
    cargoAvailableEnd?: number | null,
    vessel?: {
      __typename?: 'ConnectingVessel',
      id: number,
      name: string,
      mmsi: number,
      imo: number,
      callSign: string,
      flagCode: string,
      flagName: string,
      type?: Types.ConnectingType | null,
      tracking?: boolean | null
    } | null,
    port?: {
      __typename?: 'Location',
      id: number,
      description: string,
      displayCode?: string | null
    } | null
  }
};

export type GetConnectingShipPortVisitQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetConnectingShipPortVisitQuery = {
  __typename?: 'Query',
  connectingShipPortVisit: {
    __typename?: 'ConnectingShipPortVisit',
    id: number,
    from?: number | null,
    until?: number | null,
    lastUpdateFromAgentOn?: number | null,
    location: {
      __typename?: 'Location',
      id: number,
      description: string,
      type: Types.LocationType,
      subLocations?: Array<{
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      }> | null,
      locationGroups: Array<{
        __typename?: 'Location',
        code?: string | null,
        id: number,
        description: string,
        type: Types.LocationType
      }>
    },
    agent?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    ship: {
      __typename?: 'Ship',
      id: number,
      name: string,
      bargeType?: Types.BargeType | null,
      mmsi?: number | null,
      eni?: string | null,
      planningNotes?: string | null,
      tanks: Array<{
        __typename?: 'Tank',
        id: number,
        positionNumber: number
      }>
    },
    connectingShipBerthings?: Array<{
      __typename?: 'ConnectingShipBerthing',
      window?: {
        __typename?: 'TimeWindow',
        from?: number | null,
        to?: number | null
      } | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      } | null
    }> | null
  }
};

export type GetConnectingVisitBerthPlanningQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetConnectingVisitBerthPlanningQuery = {
  __typename?: 'Query',
  connectingVisitBerthPlanning?: {
    __typename?: 'BerthPlanning',
    planningPerAgency?: Array<{
      __typename?: 'BerthAgencyPlanning',
      agency?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      planningPerLocation?: Array<{
        __typename?: 'BerthLocationPlanning',
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType,
          subLocations?: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType,
            locationGroups: Array<{
              __typename?: 'Location',
              code?: string | null,
              id: number,
              description: string,
              type: Types.LocationType
            }>
          }> | null,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        visits?: Array<{
          __typename?: 'ConnectingShipPortVisit',
          id: number,
          from?: number | null,
          until?: number | null,
          lastUpdateFromAgentOn?: number | null,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          },
          cargoActions?: Array<{
            __typename?: 'CargoAction',
            id: number,
            start?: number | null,
            end?: number | null,
            type: Types.CallType,
            simulatedTimestamp?: boolean | null,
            displayAsWindow?: boolean | null,
            weight?: number | null,
            volume?: number | null,
            reference?: string | null,
            notes?: string | null,
            connectingVisitNotes?: string | null,
            surveyor?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType,
              contacts?: Array<{
                __typename?: 'Contact',
                name?: string | null
              }> | null,
              locationGroups: Array<{
                __typename?: 'Location',
                code?: string | null,
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null,
            cargo: {
              __typename?: 'Cargo',
              isWeightPrimary: boolean,
              isVolumePrimary: boolean,
              waterLevelOptimised: boolean,
              product?: {
                __typename?: 'Product',
                id: number,
                name: string
              } | null,
              charter?: {
                __typename?: 'SalesCharter',
                id: number,
                charterNumber: string,
                type: Types.CharterType,
                debtor: {
                  __typename?: 'Relation',
                  id: number,
                  name: string
                }
              } | null,
              firstLoadingAction?: {
                __typename?: 'CargoAction',
                id: number,
                type: Types.CallType,
                start?: number | null,
                end?: number | null,
                displayAsWindow?: boolean | null,
                simulatedTimestamp?: boolean | null,
                location?: {
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType,
                  locationGroups: Array<{
                    __typename?: 'Location',
                    code?: string | null,
                    id: number,
                    description: string,
                    type: Types.LocationType
                  }>
                } | null,
                call?: {
                  __typename?: 'Call',
                  id: number,
                  pta?: number | null,
                  location: {
                    __typename?: 'Location',
                    id: number,
                    description: string,
                    type: Types.LocationType,
                    locationGroups: Array<{
                      __typename?: 'Location',
                      code?: string | null,
                      id: number,
                      description: string,
                      type: Types.LocationType
                    }>
                  }
                } | null
              } | null,
              lastDischargingAction?: {
                __typename?: 'CargoAction',
                id: number,
                type: Types.CallType,
                start?: number | null,
                end?: number | null,
                displayAsWindow?: boolean | null,
                simulatedTimestamp?: boolean | null,
                location?: {
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType,
                  locationGroups: Array<{
                    __typename?: 'Location',
                    code?: string | null,
                    id: number,
                    description: string,
                    type: Types.LocationType
                  }>
                } | null,
                call?: {
                  __typename?: 'Call',
                  id: number,
                  pta?: number | null,
                  location: {
                    __typename?: 'Location',
                    id: number,
                    description: string,
                    type: Types.LocationType,
                    locationGroups: Array<{
                      __typename?: 'Location',
                      code?: string | null,
                      id: number,
                      description: string,
                      type: Types.LocationType
                    }>
                  }
                } | null
              } | null
            },
            call?: {
              __typename?: 'Call',
              id: number,
              pta?: number | null,
              eta?: number | null,
              location: {
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType,
                contacts?: Array<{
                  __typename?: 'Contact',
                  name?: string | null
                }> | null,
                locationGroups: Array<{
                  __typename?: 'Location',
                  code?: string | null,
                  id: number,
                  description: string,
                  type: Types.LocationType
                }>
              },
              voyage: {
                __typename?: 'Voyage',
                id: number,
                ship: {
                  __typename?: 'Ship',
                  id: number,
                  name: string
                }
              }
            } | null,
            connectingShipPortVisit?: {
              __typename?: 'ConnectingShipPortVisit',
              id: number,
              from?: number | null,
              until?: number | null,
              lastUpdateFromAgentOn?: number | null,
              location: {
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType,
                locationGroups: Array<{
                  __typename?: 'Location',
                  code?: string | null,
                  id: number,
                  description: string,
                  type: Types.LocationType
                }>
              },
              agent?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string,
                bargeType?: Types.BargeType | null,
                mmsi?: number | null,
                eni?: string | null,
                planningNotes?: string | null,
                tanks: Array<{
                  __typename?: 'Tank',
                  id: number,
                  positionNumber: number
                }>
              },
              connectingShipBerthings?: Array<{
                __typename?: 'ConnectingShipBerthing',
                window?: {
                  __typename?: 'TimeWindow',
                  from?: number | null,
                  to?: number | null
                } | null,
                location?: {
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType,
                  locationGroups: Array<{
                    __typename?: 'Location',
                    code?: string | null,
                    id: number,
                    description: string,
                    type: Types.LocationType
                  }>
                } | null
              }> | null
            } | null,
            connectingShipBerthing?: {
              __typename?: 'ConnectingShipBerthing',
              id?: number | null
            } | null
          } | null> | null,
          connectingShipBerthings?: Array<{
            __typename?: 'ConnectingShipBerthing',
            id?: number | null,
            createdOn?: number | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType,
              contacts?: Array<{
                __typename?: 'Contact',
                name?: string | null
              }> | null,
              locationGroups: Array<{
                __typename?: 'Location',
                code?: string | null,
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            connectingShipPortVisit?: {
              __typename?: 'ConnectingShipPortVisit',
              id: number,
              lastUpdateFromAgentOn?: number | null
            } | null,
            cargoActions?: Array<{
              __typename?: 'CargoAction',
              id: number,
              displayAsWindow?: boolean | null,
              type: Types.CallType,
              start?: number | null,
              end?: number | null,
              simulatedTimestamp?: boolean | null,
              weight?: number | null,
              volume?: number | null,
              connectingVisitNotes?: string | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType,
                contacts?: Array<{
                  __typename?: 'Contact',
                  name?: string | null
                }> | null,
                locationGroups: Array<{
                  __typename?: 'Location',
                  code?: string | null,
                  id: number,
                  description: string,
                  type: Types.LocationType
                }>
              } | null,
              cargo: {
                __typename?: 'Cargo',
                isWeightPrimary: boolean,
                isVolumePrimary: boolean,
                waterLevelOptimised: boolean,
                product?: {
                  __typename?: 'Product',
                  id: number,
                  name: string
                } | null,
                charter?: {
                  __typename?: 'SalesCharter',
                  id: number,
                  charterNumber: string,
                  type: Types.CharterType,
                  debtor: {
                    __typename?: 'Relation',
                    id: number,
                    name: string
                  }
                } | null,
                firstLoadingAction?: {
                  __typename?: 'CargoAction',
                  id: number,
                  type: Types.CallType,
                  start?: number | null,
                  end?: number | null,
                  displayAsWindow?: boolean | null,
                  simulatedTimestamp?: boolean | null,
                  location?: {
                    __typename?: 'Location',
                    id: number,
                    description: string,
                    type: Types.LocationType,
                    locationGroups: Array<{
                      __typename?: 'Location',
                      code?: string | null,
                      id: number,
                      description: string,
                      type: Types.LocationType
                    }>
                  } | null,
                  call?: {
                    __typename?: 'Call',
                    id: number,
                    pta?: number | null,
                    location: {
                      __typename?: 'Location',
                      id: number,
                      description: string,
                      type: Types.LocationType,
                      locationGroups: Array<{
                        __typename?: 'Location',
                        code?: string | null,
                        id: number,
                        description: string,
                        type: Types.LocationType
                      }>
                    }
                  } | null
                } | null,
                lastDischargingAction?: {
                  __typename?: 'CargoAction',
                  id: number,
                  type: Types.CallType,
                  start?: number | null,
                  end?: number | null,
                  displayAsWindow?: boolean | null,
                  simulatedTimestamp?: boolean | null,
                  location?: {
                    __typename?: 'Location',
                    id: number,
                    description: string,
                    type: Types.LocationType,
                    locationGroups: Array<{
                      __typename?: 'Location',
                      code?: string | null,
                      id: number,
                      description: string,
                      type: Types.LocationType
                    }>
                  } | null,
                  call?: {
                    __typename?: 'Call',
                    id: number,
                    pta?: number | null,
                    location: {
                      __typename?: 'Location',
                      id: number,
                      description: string,
                      type: Types.LocationType,
                      locationGroups: Array<{
                        __typename?: 'Location',
                        code?: string | null,
                        id: number,
                        description: string,
                        type: Types.LocationType
                      }>
                    }
                  } | null
                } | null
              },
              call?: {
                __typename?: 'Call',
                id: number,
                pta?: number | null,
                eta?: number | null,
                location: {
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType,
                  contacts?: Array<{
                    __typename?: 'Contact',
                    name?: string | null
                  }> | null,
                  locationGroups: Array<{
                    __typename?: 'Location',
                    code?: string | null,
                    id: number,
                    description: string,
                    type: Types.LocationType
                  }>
                },
                voyage: {
                  __typename?: 'Voyage',
                  id: number,
                  ship: {
                    __typename?: 'Ship',
                    id: number,
                    name: string
                  }
                }
              } | null,
              connectingShipPortVisit?: {
                __typename?: 'ConnectingShipPortVisit',
                id: number,
                ship: {
                  __typename?: 'Ship',
                  id: number
                },
                location: {
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType,
                  contacts?: Array<{
                    __typename?: 'Contact',
                    name?: string | null
                  }> | null,
                  locationGroups: Array<{
                    __typename?: 'Location',
                    code?: string | null,
                    id: number,
                    description: string,
                    type: Types.LocationType
                  }>
                }
              } | null,
              connectingShipBerthing?: {
                __typename?: 'ConnectingShipBerthing',
                id?: number | null,
                location?: {
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType,
                  contacts?: Array<{
                    __typename?: 'Contact',
                    name?: string | null
                  }> | null,
                  locationGroups: Array<{
                    __typename?: 'Location',
                    code?: string | null,
                    id: number,
                    description: string,
                    type: Types.LocationType
                  }>
                } | null
              } | null
            } | null> | null
          }> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
};


export const GetConnectingVisitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectingVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectingVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"vessel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"cargoOpening"}},{"kind":"Field","name":{"kind":"Name","value":"cargoClosing"}},{"kind":"Field","name":{"kind":"Name","value":"cargoAvailableStart"}},{"kind":"Field","name":{"kind":"Name","value":"cargoAvailableEnd"}},{"kind":"Field","name":{"kind":"Name","value":"callReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"port"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"numLoadingGreen"}},{"kind":"Field","name":{"kind":"Name","value":"numLoadingOrange"}},{"kind":"Field","name":{"kind":"Name","value":"numLoadingRed"}},{"kind":"Field","name":{"kind":"Name","value":"numDischargingGreen"}},{"kind":"Field","name":{"kind":"Name","value":"numDischargingOrange"}},{"kind":"Field","name":{"kind":"Name","value":"numDischargingRed"}}]}}]}}]} as unknown as DocumentNode<GetConnectingVisitsQuery, GetConnectingVisitsQueryVariables>;
export const GetConnectingVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectingVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectingVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vessel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"imo"}},{"kind":"Field","name":{"kind":"Name","value":"callSign"}},{"kind":"Field","name":{"kind":"Name","value":"flagCode"}},{"kind":"Field","name":{"kind":"Name","value":"flagName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"port"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"cargoOpening"}},{"kind":"Field","name":{"kind":"Name","value":"cargoClosing"}},{"kind":"Field","name":{"kind":"Name","value":"cargoAvailableStart"}},{"kind":"Field","name":{"kind":"Name","value":"cargoAvailableEnd"}}]}}]}}]} as unknown as DocumentNode<GetConnectingVisitQuery, GetConnectingVisitQueryVariables>;
export const GetConnectingShipPortVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectingShipPortVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"subLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectingShipPortVisit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<GetConnectingShipPortVisitQuery, GetConnectingShipPortVisitQueryVariables>;
export const GetConnectingVisitBerthPlanningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectingVisitBerthPlanning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectingVisitBerthPlanning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planningPerAgency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planningPerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"subLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"surveyor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectingShipPortVisit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<GetConnectingVisitBerthPlanningQuery, GetConnectingVisitBerthPlanningQueryVariables>;